import React from "react";
import { RCCLov } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { ILovSelectFirstOption } from "../interface";

const LovBudgetPlanYears: React.FC<ILovSelectFirstOption>
 = ({
 	name,
 	control,
 	label,
 	extraParametersOnLoad,
 	setValue,
 	...rest
 }) => {
 	const { translate } = useTranslation();
	  
 	return(
 		<RCCLov 
 			label={label}
 			name={name} 
 			control={control}
 			routeAPI="FinancialManagement/LovYears"
 			valueProperty="Description"
 			labelProperty="Description"
 			elementsPerPage={20}
 			extraParametersOnLoad={extraParametersOnLoad || {
 				budgetPlanId: 0
 			}}
 			selectFirstOption={setValue ? {
 				setValueForm: setValue 
 			} : undefined}
 			placeholder={translate("Digite para filtrar as opções")}
 			{...rest}
 		/>
 	);
 };

export default LovBudgetPlanYears;
